import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isOpen: false,
  modalType: null,
  modalProps: {},
  createElementDrafts: {},
};

const modalSlice = createSlice({
  name: 'modals',
  initialState,
  reducers: {
    openModal: (state, action) => {
      const { modalType, modalProps } = action.payload;
      state.isOpen = true;
      state.modalType = modalType;
      state.modalProps = modalProps || {};
    },
    closeModal: (state) => {
      state.isOpen = false;
      state.modalType = null;
      state.modalProps = {};
    },
    saveCreateElementDraft: (state, action) => {
      const { key, formData, uiState, currentPage } = action.payload || {};

      if (!key) return;

      const existingDraft = state.createElementDrafts[key] || {};

      state.createElementDrafts[key] = {
        formData: formData !== undefined ? formData : existingDraft.formData || {},
        uiState: {
          ...(existingDraft.uiState || {}),
          ...(uiState || {}),
        },
        currentPage: currentPage ?? existingDraft.currentPage ?? 0,
      };
    },
    clearCreateElementDraft: (state, action) => {
      const key = action.payload;

      if (!key) return;

      delete state.createElementDrafts[key];
    },
  },
});

export const {
  openModal,
  closeModal,
  saveCreateElementDraft,
  clearCreateElementDraft,
} = modalSlice.actions;
export default modalSlice.reducer;
